<div class="position-relative h-100">
  <div class="side-bar">
    <div class="d-flex justify-content-between align-items-center pb-px-12">
      <mat-label class="fs-20 fw-700">{{ data.name }}</mat-label>
      <img (click)="dialogRef.close()" src="/assets/icons/close-modal-primary.svg"
           class="cursor-pointer"/>
    </div>

    <div class="mt-px-32">
      <app-button text="Définir comme siège social"
                  (handleClick)="defineSocial()" [disabled]="data.issocial"
                  [stroked]="true"></app-button>
      <app-text-separator text="Adresse du site" [innerClass]="'my-px-24'"></app-text-separator>
      <div class="mb-px-16">
        <div class="fw-3 fs-13">Nom du site</div>
        <div class="fs-16 fw-4">{{ data.name || 'N/A'}}</div>
      </div>

      <div class="mb-px-16">
        <div class="fw-3 fs-13">Adresse du site</div>
        <div class="fs-16 fw-4">{{ data.adress || 'N/A'}}</div>
      </div>

      <div class="col-6 mb-px-16">
        <div class="fw-3 fs-13">Pays</div>
        <div class="fs-16 fw-4">{{ data.pays || 'N/A'}}</div>

        <div class="fw-3 fs-13 mt-px-16">Code postal</div>
        <div class="fs-16 fw-4">{{ data.codePostale || 'N/A'}}</div>
      </div>

      <div class="col-6 mb-px-16">
        <div class="fw-3 fs-13">Ville</div>
        <div class="fs-16 fw-4">{{ data.ville || 'N/A'}}</div>

        <div class="fw-3 fs-13 mt-px-16">Département</div>
        <div class="fs-16 fw-4">{{ data.departmentName || 'N/A'}}</div>
      </div>

      <div class="mb-px-16">
        <div class="fw-3 fs-13">CEDEX</div>
        <div class="fs-16 fw-4">{{ data.cededx || 'N/A' }}</div>
      </div>
      <app-text-separator text="Photos du site" [innerClass]="'my-px-24'"></app-text-separator>


      <div *ngIf="!data.firstPhoto" class="text-center text-secondary">
        Pas de photo pour ce site
      </div>
      <div class="drop-photo-area">
        <img [src]="displayImg(data.firstPhoto)"  *ngIf="data.firstPhoto" alt="">
        <img [src]="displayImg(data.secondPhoto)" *ngIf="data.secondPhoto"  alt="">
      </div>

    </div>

  </div>
  <div class="footer">
    <div class="d-flex justify-content-end">
      <app-button [text]="this.data.isvisible ? 'Masquer le site' : 'Afficher le site'" [stroked]="true" srcIcon="/assets/icons/hide-primary.svg" color="primary"
                  class="me-2" (handleClick)="hideSiteDialog()"></app-button>
      <app-button text="Modifier" [stroked]="true" srcIcon="/assets/icons/copy-primary.svg" color="primary" (handleClick)="openAddSiteDialog()"
                  class="me-2"></app-button>
    </div>
  </div>

</div>
